import { cssVar, mode, type SystemStyleFunction } from "@chakra-ui/theme-tools";

const $bg = cssVar("tooltip-bg");
const $arrowBg = cssVar("popper-arrow-bg");

const baseStyle: SystemStyleFunction = (props) => {
  const bg = mode("gray.700", "grey.300")(props);
  return {
    [$bg.variable]: `colors.${bg}`,
    px: "12px",
    py: "6px",
    bg: [$bg.reference],
    [$arrowBg.variable]: [$bg.reference],
    color: mode("whiteAlpha.900", "grey.900")(props),
    borderRadius: "md",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "320px",
    zIndex: "tooltip",
  };
};

export default {
  baseStyle,
};
